import { combineReducers } from 'redux'
import keyBy from 'lodash/keyBy'
import omit from 'lodash/omit'

// ACTIONS
export const FETCH_SUCCESS = 'company/candidateDetails/candidate/FETCH_SUCCESS'

export const RESET = 'company/candidateDetails/candidate/RESET'

export const TOGGLE_FETCHING = 'company/candidateDetails/candidate/TOGGLE_FETCHING'
export const TOGGLE_HAS_FETCHED = 'company/candidateDetails/candidate/TOGGLE_HAS_FETCHED'
export const TOGGLE_HAS_FETCH_ERROR = 'company/candidateDetails/candidate/TOGGLE_HAS_FETCH_ERROR'

export const SET_FAVOURITE_SUCCESS = 'company/candidateDetails/candidate/SET_FAVOURITE_SUCCESS'
export const UNSET_FAVOURITE_SUCCESS = 'company/candidateDetails/candidate/UNSET_FAVOURITE_SUCCESS'

// ACTION CREATORS
export const fetchSuccess = result => ({
  type: FETCH_SUCCESS,
  payload: { ...result },
})

export const toggleFetching = isFetching => ({
  type: TOGGLE_FETCHING,
  payload: { isFetching },
})

export const toggleHasFetched = hasFetched => ({
  type: TOGGLE_HAS_FETCHED,
  payload: { hasFetched, hasFetchError: '' },
})

export const toggleHasFetchError = hasFetchError => ({
  type: TOGGLE_HAS_FETCH_ERROR,
  payload: { hasFetchError },
})

export const setFavouriteSuccess = data => ({
  type: SET_FAVOURITE_SUCCESS,
  payload: data,
})

export const unsetFavouriteSuccess = creator_id => ({
  type: UNSET_FAVOURITE_SUCCESS,
  payload: creator_id,
})

export const reset = () => ({
  type: RESET,
})

// REDUCERS
const defaultUtil = {
  isFetching: true,
  hasFetched: false,
  isHiding: false,
  hasFetchError: '',
}

const utils = (state = defaultUtil, { type, payload }) => {
  switch (type) {
    case TOGGLE_HAS_FETCHED:
    case TOGGLE_FETCHING:
    case TOGGLE_HAS_FETCH_ERROR:
      return {
        ...state,
        ...payload,
      }

    case RESET:
      return defaultUtil

    default:
      return state
  }
}

export const defaultCandidate = {
  name: '',
  work_history: [],
  education: [],
  skills: '',
  experience: [],
  projects: [],
  online_profiles: [],
  likes: {},
}

export const member = (state = defaultCandidate, { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        ...payload,
        likes: keyBy(payload.likes, 'creator_id'),
      }

    case SET_FAVOURITE_SUCCESS:
      return {
        ...state,
        likes: {
          ...state.likes,
          [payload.creator_id]: payload,
        },
      }

    case UNSET_FAVOURITE_SUCCESS:
      return {
        ...state,
        likes: omit(state.likes, payload),
      }

    case RESET:
      return defaultCandidate

    default:
      return state
  }
}

export default combineReducers({
  member,
  utils,
})
